import { render, staticRenderFns } from "./Details.vue.js?vue&type=template&id=5f9e2474&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=template&id=5f9e2474&scoped=true"
import script from "./Details.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue.sass?vue&type=style&index=0&id=5f9e2474&prod&lang=sass&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=style&index=0&id=5f9e2474&prod&lang=sass&scoped=true"
import style1 from "./Details.vue.css?vue&type=style&index=1&id=5f9e2474&prod&lang=css!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=style&index=1&id=5f9e2474&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9e2474",
  null
  
)

export default component.exports